/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_FlatsInputs */

const en_val_flats = /** @type {(inputs: Val_FlatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Flats`)
};

const es_val_flats = /** @type {(inputs: Val_FlatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zapatos planos`)
};

const fr_val_flats = /** @type {(inputs: Val_FlatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chaussures plates`)
};

const de_val_flats = /** @type {(inputs: Val_FlatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Flache Schuhe`)
};

const ja_val_flats = /** @type {(inputs: Val_FlatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`フラットシューズ`)
};

const zh_val_flats = /** @type {(inputs: Val_FlatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`平底鞋`)
};

const ar_val_flats = /** @type {(inputs: Val_FlatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أحذية مسطحة`)
};

const id_val_flats = /** @type {(inputs: Val_FlatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sepatu Datar`)
};

const it_val_flats = /** @type {(inputs: Val_FlatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scarpe Basse`)
};

const ru_val_flats = /** @type {(inputs: Val_FlatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Балетки/на плоской подошве`)
};

const pt_val_flats = /** @type {(inputs: Val_FlatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sapatilhas`)
};

const ko_val_flats = /** @type {(inputs: Val_FlatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`플랫 슈즈`)
};

/**
* | output |
* | --- |
* | "Flats" |
*
* @param {Val_FlatsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_flats = /** @type {((inputs?: Val_FlatsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_FlatsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_flats(inputs)
	if (locale === "es") return es_val_flats(inputs)
	if (locale === "fr") return fr_val_flats(inputs)
	if (locale === "de") return de_val_flats(inputs)
	if (locale === "ja") return ja_val_flats(inputs)
	if (locale === "zh") return zh_val_flats(inputs)
	if (locale === "ar") return ar_val_flats(inputs)
	if (locale === "id") return id_val_flats(inputs)
	if (locale === "it") return it_val_flats(inputs)
	if (locale === "ru") return ru_val_flats(inputs)
	if (locale === "pt") return pt_val_flats(inputs)
	return ko_val_flats(inputs)
});